let service={}
if (window.location.href.startsWith('http://localhost')) {
    service.api = 'http://localhost:9003'
}else{
    service.api = 'https://api-imageai.pyther.com'
}
export default service;
